/*
 * Copyright (c) 2024 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { AnvilorFormsAppStoreContext } from "../anvilor-forms-app-store.service";
import { AnvilorFormsAppStore } from "../anvilor-forms-app-store.service";
import { Observable } from "rxjs";
import { tap } from "rxjs";
import { switchMap } from "rxjs";
import { iif } from "rxjs";
import { EMPTY } from "rxjs";
import { debounceTime } from "rxjs";
import { combineLatest } from "rxjs";
import { firstValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { RuiStore } from "@anvilor/ngx-rui";
import { EDIT_KEY_QPARAM } from "../../consts";

const AUTOSAVE_DEBOUNCE_TIME = 500;

export class AnvilorFormsAppAutosave {
  private store: AnvilorFormsAppStore;
  private rui: RuiStore;
  readonly autosaveKey$: Observable<string>;

  constructor(ctx: AnvilorFormsAppStoreContext) {
    this.store = ctx.store;
    this.rui = ctx.ruiLegacy;

    this.autosaveKey$ = ctx.qparams.queryParams$.pipe(
      map((qp) => qp.get(EDIT_KEY_QPARAM) ?? ""),
      map((edit_key) => `${window.location.pathname}|${edit_key}`)
    );
  }

  async getAutosaveData(): Promise<any> {
    const key = await firstValueFrom(this.autosaveKey$);
    const raw = localStorage.getItem(key);
    return raw === null ? {} : JSON.parse(raw);
  }

  initialize(): void {
    this.store.subscribeTo(
      this.store.autosaveEnabled$.pipe(
        switchMap((enabled) =>
          iif(
            () => enabled,
            combineLatest([this.rui.data.root$, this.autosaveKey$]).pipe(
              debounceTime(AUTOSAVE_DEBOUNCE_TIME),
              tap(([data, key]) => localStorage.setItem(key, JSON.stringify(data)))
            ),
            EMPTY
          )
        )
      )
    );
  }
}
